import { Button, Modal, Typography } from 'antd';
import styles from './index.module.scss';

type Props = {
	open: boolean;
	onClose: () => void;
};

const TimeLogsRulesModal = ({ open, onClose }: Props) => {
	return (
		<Modal
			title={
				<span style={{ color: '#584495', fontWeight: 600 }}>
					How time logs are calculated
				</span>
			}
			open={open}
			onCancel={onClose}
			closable={false}
			footer={[
				<Button key="close" type="primary" onClick={onClose}>
					Close
				</Button>,
			]}
			width={900}
			centered
			destroyOnClose
		>
			<Typography.Paragraph style={{ marginBottom: '1rem' }}>
				This screen uses the rules below when you enter or review hours.
				They help keep regular time, overtime, and shift differential
				consistent with your shift setup.
			</Typography.Paragraph>

			<div className={styles.section}>
				<div className={styles.sectionTitle}>Shifts</div>
				<Typography.Text>
					Each person&apos;s assignment is either a{' '}
					<strong>day shift</strong> or a <strong>night shift</strong>.
				</Typography.Text>
			</div>

			<div className={styles.section}>
				<div className={styles.sectionTitle}>Worked hours</div>
				<Typography.Text>
					<strong>Total worked hours = regular hours + overtime hours.</strong>
				</Typography.Text>
			</div>

			<div className={styles.section}>
				<div className={styles.sectionTitle}>Regular hours</div>
				<Typography.Text>
					The <strong>regular</strong> portion comes from the{' '}
					<strong>shift master</strong> setup for that shift (the
					scheduled or expected regular time for that day).
				</Typography.Text>
			</div>

			<div className={styles.section}>
				<div className={styles.sectionTitle}>Overtime types</div>
				<Typography.Text>Overtime is split as follows:</Typography.Text>
				<ul className={styles.list}>
					<li>
						<strong>Weekday overtime</strong> — Hours beyond regular
						time on <strong>Monday through Saturday</strong>, when that
						day is <strong>not</strong> a holiday.
					</li>
					<li>
						<strong>Double overtime</strong> — Overtime hours on a{' '}
						<strong>Sunday</strong> or on a <strong>holiday</strong>{' '}
						(when Sunday/holiday rules apply).
					</li>
				</ul>
			</div>

			<div className={styles.section}>
				<div className={styles.sectionTitle}>
					Shift differential (SDH)
				</div>
				<Typography.Text>
					<strong>Shift differential hours apply only to the night shift</strong>{' '}
					— not to day shift.
				</Typography.Text>
			</div>

			<div className={styles.section}>
				<div className={styles.sectionTitle}>Holidays</div>
				<Typography.Text>
					If someone <strong>works (5 hours) on a holiday</strong>, enter their
					time as <strong>regular hours (8 hours) plus overtime hours (5 hours)</strong>{' '}
					(both parts) Total hours would be 13 hours . The system needs that breakdown for payroll.
				</Typography.Text>
			</div>

			<div className={styles.section}>
				<div className={styles.sectionTitle}>
					Sunday as regular hours
				</div>
				<Typography.Text>
					When this option is <strong>on</strong>,{' '}
					<strong>Sunday is treated like a normal weekday</strong> (the
					same rules as Monday–Saturday for how hours are classified).
					When it is <strong>off</strong>, Sunday follows the Sunday /
					overtime rules described above.
				</Typography.Text>
			</div>
		</Modal>
	);
};

export default TimeLogsRulesModal;
